module.exports = __webpack_public_path__ + "static/img/1.3a21fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/1.png
// module id = DS7T
// module chunks = 0